import { render } from "./CardProm.vue?vue&type=template&id=366e6110"
import script from "./CardProm.vue?vue&type=script&lang=js"
export * from "./CardProm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__